import { useMemo } from 'react';
import { FlightsShoppingPwaFlightInformationResults } from '__generated__/api';

import { useStores } from '.';
import { toJS } from 'mobx';

export const useFlightsDetailCriteriaInput = (): Pick<
  FlightsShoppingPwaFlightInformationResults.Variables,
  'flightsDetailCriteria'
> => {
  const { informationCriteriaStore, flightsSupportedAncillariesStore } = useStores();
  const {
    journeyContinuationId,
    originalBookingId,
    upsellOfferToken
  } = informationCriteriaStore.informationCriteria.flightsDetailCriteria;
  const { sideSheetQueryContext } = informationCriteriaStore;
  const { selectedAncillaryId: ancillaryId } = flightsSupportedAncillariesStore;
  const addOnRequested = toJS(informationCriteriaStore.sideSheetTempValues.addOnRequested);
  const inputs = useMemo(
    () => ({
      flightsDetailCriteria: {
        journeyContinuationId,
        ...(originalBookingId && { originalBookingId }),
        ...(upsellOfferToken && { upsellOfferToken }),
        ...(ancillaryId && { ancillaryId })
      },
      sideSheetQueryContext: {
        addOnRequested: addOnRequested,
        journeyContinuationId: sideSheetQueryContext.journeyContinuationId,
        isFirstLoad: sideSheetQueryContext.isFirstLoad
      }
    }),
    [
      journeyContinuationId,
      originalBookingId,
      upsellOfferToken,
      ancillaryId,
      addOnRequested,
      sideSheetQueryContext.journeyContinuationId,
      sideSheetQueryContext.isFirstLoad
    ]
  );

  return inputs;
};
